import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import { blue } from "@mui/material/colors";
import FacebookIcon from "@mui/icons-material/Facebook";
import XIcon from "@mui/icons-material/X";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import image1 from "../../../../assets/advisory/edna.png";

const Details = () => {
  return (
    <Box margin={{ xs: "30% 0%", sm: "10% 0%" }}>
      <Typography variant={"subtitle2"} fontWeight={700}>
        Technical Director
      </Typography>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        flexWrap={"wrap"}
        width={{ xs: "100%", sm: "40%" }}
        marginLeft={{ xs: "0%", sm: "0%" }}
      >
        <Box
          width={{ xs: "100%", sm: "100%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
        >
          <Typography
            variant={"h3"}
            fontWeight={900}
            textAlign={"left"}
            color={"#00AEEF"}
            paddingBottom={"1%"}
          >
            Edna Eligado Dionisio
          </Typography>
        </Box>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
          width={{ xs: "50%", sm: "35%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
        >
          <Box
            component="a"
            underline="none"
            target={"_blank"}
            href="https://www.facebook.com/"
            title="Facebook"
          >
            <Avatar
              sx={{
                bgcolor: blue[900],
                width: 46,
                height: 46,
              }}
            >
              <FacebookIcon />
            </Avatar>
          </Box>
          <Box
            component="a"
            underline="none"
            target={"_blank"}
            href="https://www.twitter.com/"
            title="Twitter"
          >
            <Avatar
              sx={{
                bgcolor: "#000",
                width: 46,
                height: 46,
              }}
            >
              <XIcon />
            </Avatar>
          </Box>
          <Box
            component="a"
            underline="none"
            target={"_blank"}
            href="https://www.linkedin.com/in/"
            title="LinkedIn"
          >
            <Avatar
              sx={{
                bgcolor: blue[700],
                width: 46,
                height: 46,
              }}
            >
              <LinkedInIcon />
            </Avatar>
          </Box>
        </Box>
      </Box>
      <Grid container marginTop={{ xs: "10%", sm: "2%" }}>
        <Grid
          item
          xs={12}
          sm={4}
          paddingRight={{ xs: "0%", sm: "3%" }}
          paddingTop={{ xs: "5%", sm: "0%" }}
        >
          <Box
            component="img"
            height={{ xs: "40vh", sm: "350px" }}
            paddingBottom={{ xs: "7%", sm: "0%" }}
            sx={{
              objectFit: "cover",
              position: "relative",
              overflow: "hidden",
              borderRadius: "5px",
              width: "100%",
            }}
            src={image1}
            alt={"edna_image"}
          />
        </Grid>
        <Grid item xs={12} sm={4} paddingRight={{ xs: "0%", sm: "2%" }}>
          <Typography
            variant="body1"
            color={"#4f4f4f"}
            paragraph
            lineHeight={1.5}
          >
            Edna is an accomplished Professional with prestigious experience of
            33 years in spearheading cross-functional roles encompassing
            Technical Farm Management in Aquaculture and Fisheries, determining
            a Business Unit’s mission, and Strategic Direction with an inherent
            capability to formulate and implement tactical initiatives for
            achieving corporate goals.
          </Typography>
          <Typography
            variant="body1"
            color={"#4f4f4f"}
            paragraph
            lineHeight={1.5}
            paddingTop={{ xs: "0.5%", sm: "2%" }}
          >
            She has a Masters Degree in Aquaculture and gained a lot of
            knowledge in Fish Breeding and Genetics. She is an International
            Trainer and Resource Speaker of various Conferences and Trainings as
            far as Aquaculture, Fisheries, and Genetics Research is concerned.
            She has been recognized as an Excellent Aquaculture Specialist.
            She’s worked in some of the largest organizations from Asian
            countries, and Africa in the Field of Aquaculture, Research and
            Development that has gone through huge growth and challenges and
            also managed to develop key skill sets in Commercial Fish Hatchery
            and Grow out (Freshwater and Marine fish species) within developing
            organizations.
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={4}
          paddingRight={{ xs: "0%", sm: "2%" }}
          paddingTop={{ xs: "0.5%", sm: "0%" }}
        >
          <Typography variant="body1" color={"#4f4f4f"} paragraph>
            Edna as a Pioneer- Researcher/ Scientist worked on a 10-year
            Collaborative research project on Genetic Improvement of Farmed
            Tilapias (GIFT) implemented by the then International Center for
            Living Aquatic Resources Management (ICLARM), which is now known as
            the World Fish Center (WFC) with collaborating agencies like: the
            Bureau of Fisheries and Aquatic Resources, National Freshwater
            Fisheries Technology Research Center (BFAR-NFFTRC), Science City of
            Munoz, Nueva Ecija; the University of the Philippines, Marine
            Science Institute (UP-MSI); Freshwater Aquaculture Center of Central
            Luzon State University, Philippines; and Aquaculture Research,
            Norway (AKVAFORSK).
          </Typography>
          <Typography
            variant="body1"
            color={"#4f4f4f"}
            paragraph
            paddingTop={{ xs: "0.5%", sm: "2%" }}
          >
            This is a multi-Million-dollar project, funded by Asian Development
            Bank (ADB) and United Nations Development Program (UNDP). Due to a
            long years of hands-on experience, she gathered various Awards and
            been Highly Recognized as ‘Woman In Aquaculture.’ Edna’s expertise
            brought various Organization to encourage them to work with her.
            Presently, she is with Aquatic Afrique Hub Network (AHAN) as a
            Technical Director-Fish Business.
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Details;
